export const getIntegrationSyncPolicy = ({
  hasLegacyEhrProfile,
  hasMultiple,
  isLegacyEpicFhirAuth,
  supportsGetSchedule,
  supportsSyncNotes,
  supportsSyncSectionalNotes,
}: {
  hasLegacyEhrProfile: boolean;
  hasMultiple: boolean;
  isLegacyEpicFhirAuth: boolean;
  supportsGetSchedule?: boolean;
  supportsSyncNotes?: boolean;
  supportsSyncSectionalNotes?: boolean;
}) => {
  const canSyncSchedule =
    hasLegacyEhrProfile || hasMultiple || supportsGetSchedule !== false;

  const canSyncNotes =
    !!isLegacyEpicFhirAuth ||
    hasLegacyEhrProfile ||
    supportsSyncNotes !== false ||
    !!supportsSyncSectionalNotes;

  const canSyncSectionalNotes = supportsSyncSectionalNotes ?? false;

  return {
    canSyncSchedule,
    canSyncNotes,
    canSyncSectionalNotes,
  };
};
